export const AVAILABLE_LANGUAGES = [
  "fr",
  "gb",
  "en",
  "de",
  "ja",
  "it",
  "pt",
  "ko",
  "es",
  "nl",
  "dk",
  "fi",
  "se",
  "pl",
];

export type Domain = {
  name: string;
  unitSystem: "metric" | "imperial";
  defaultBraSize?: "FR" | "UK" | "EU" | "US" | "AUS" | "IT" | "JP" | "KO";
};

export type Brand = {
  name: string;
  domains: Domain[];
  config: any;
};
